import { render, staticRenderFns } from "./anchor-select.vue?vue&type=template&id=635f7a7e&scoped=true"
import script from "./anchor-select.vue?vue&type=script&lang=js"
export * from "./anchor-select.vue?vue&type=script&lang=js"
import style0 from "./anchor-select.vue?vue&type=style&index=0&id=635f7a7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635f7a7e",
  null
  
)

export default component.exports